import { forwardRef } from 'react';
import MuiSlide, { SlideProps as MuiSlideProps } from '@mui/material/Slide';

export interface SlideTransitionProps extends MuiSlideProps {
  direction?: MuiSlideProps['direction'];
}

const SlideTransition = forwardRef<any, MuiSlideProps>(
  ({ direction = 'down', ...props }, ref) => {
    return <MuiSlide ref={ref} direction={direction} {...props} />;
  }
);

export default SlideTransition;
